import { OrderStatus } from '@pidelo/models';
import EnumExtension from './enum-extension';

/**
 * @since 0.1.26
 * @author Nelson Martell <nelson6e65@gmail.com>
 */
export default class OrderStatusExtension extends EnumExtension<OrderStatus> {
  public label() {
    let label = '';

    switch (this.value) {
      case OrderStatus.Rejected:
        label = 'Rechazado';
        break;
      case OrderStatus.Received:
        label = 'Recibido';
        break;

      case OrderStatus.Confirmed:
        label = 'Confirmado';
        break;

      case OrderStatus.Delivering:
        label = 'En camino';
        break;

      case OrderStatus.Delivered:
        label = 'Entregado';
        break;

      case OrderStatus.Rated:
        label = 'Calificado';
        break;

      default:
        label = '';
    }

    return label;
  }
}
